import { useState } from 'react';
import { LuBuilding2, LuUsers, LuPlus } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';
import TopicList from '../components/Forum/TopicList';
import CreateTopicForm from '../components/Forum/CreateTopicForm';
import { useBuilding } from '../contexts/BuildingContext';

export default function Forum() {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState('building');
  const [showCreateForm, setShowCreateForm] = useState(false);
  const { currentBuilding, currentProperty } = useBuilding();

  return (
    <div className="max-w-6xl mx-auto space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">{t('forum.title')}</h1>
          <p className="text-gray-600 mt-1">
            {activeTab === 'property' ?
            t('forum.propertyDesc') :
            t('forum.buildingDesc')}
          </p>
        </div>
        <button
          onClick={() => setShowCreateForm(true)}
          className="flex items-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">
          <LuPlus className="w-5 h-5" /> {t('forum.newTopic')}
        </button>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-1 inline-flex">
        <button
          onClick={() => setActiveTab('building')}
          className={`flex items-center gap-2 px-6 py-3 rounded-lg transition ${
          activeTab === 'building' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-50'}`
          }>
          <LuUsers className="w-5 h-5" />
          <span className="font-medium">{t('forum.myBuilding')}</span>
        </button>
        <button
          onClick={() => setActiveTab('property')}
          className={`flex items-center gap-2 px-6 py-3 rounded-lg transition ${
          activeTab === 'property' ? 'bg-blue-600 text-white' : 'text-gray-600 hover:bg-gray-50'}`
          }>
          <LuBuilding2 className="w-5 h-5" />
          <span className="font-medium">{t('forum.propertyWide')}</span>
        </button>
      </div>

      {/* Topic List */}
      <TopicList scope={activeTab === 'property' ? 'property_wide' : 'building_specific'} key={activeTab} />

      {/* Create Topic Modal */}
      {showCreateForm &&
      <CreateTopicForm
        defaultScope={activeTab === 'property' ? 'property_wide' : 'building_specific'}
        onClose={() => setShowCreateForm(false)}
        onSuccess={() => {
          setShowCreateForm(false);
          window.location.reload();
        }} />
      }
    </div>);

}